import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {Modal, ModalBody, ModalHeader, ModalFooter} from 'reactstrap';
import {Selector} from '../../../../components';

import {permissionsForTask, permissionToLabels, GenerateTaskStore} from './GenerateTasksStore';
import {priorities} from "../../models";
import WorkflowTaskPriority from "../WorkflowTaskPriority";
import DayPickerInput from "react-day-picker/DayPickerInput";
import { LocaleUtils } from 'react-day-picker';

const GenerateTasks = observer(class GenerateTasks extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onComplete: PropTypes.func.isRequired
  };

  componentWillMount(){
    this.generateTasksStore = new GenerateTaskStore();
  }

  userPermissionsForLabels = () => {
    const {user} = this.props;
    return permissionsForTask.filter(task => user.permissions.indexOf(task) !== -1);
  };

  onGenerateTasksClick = (e) => {
    this.generateTasksStore
    .generateTasks(this.props.uGemser)
      .then(() => this.props.onExit && this.props.onExit());
  };

  onCancel = () => {
    const {onExit} = this.props;
    this.generateTasksStore.reset();
    onExit && onExit()
  }


  render(){
    const {isOpen, onExit, user} = this.props;
    if(!isOpen || !user) return <div />;
    const checkboxes = this.userPermissionsForLabels().map(permission =>
      permissionToLabels[permission].map(label => {
        const uid = `${permission}-${label}`;
        return <div key={uid} className="custom-control custom-checkbox">
                <input id={uid} className="custom-control-input" type="checkbox" checked={!!this.generateTasksStore.tasks[label]} onChange={(e) => this.generateTasksStore.onToggle(label, e.target.checked)}/>
                <label for={uid} className="custom-control-label">{label}</label>
              </div>;
      })
    );
    let generateBtn;
    let checkboxDisplay;
    if(checkboxes.length){
      generateBtn = <button disabled={this.generateTasksStore.isLoading || this.generateTasksStore.hasError} type="button" className="btn btn-outline-secondary" onClick={this.onGenerateTasksClick}>Generate Tasks</button>;
      checkboxDisplay = <Fragment>
        <label className="font-weight-bold">Tasks</label>
        <div>{checkboxes}</div>
        <div className="row content-spacer-top">
          <div className="col-6">
            <label className="font-weight-bold">Priority</label>
            <Selector
              required
              selected={this.generateTasksStore.priority}
              options={priorities}
              renderOption={x => <WorkflowTaskPriority priority={x.value}/>}
              getKey={x => x.value}
              placeholder="Select"
              onSelected={this.generateTasksStore.setPriority}
            />
          </div>
          <div className="col-6">
            <label className="font-weight-bold control-spacer-right">Due Date</label>
            <DayPickerInput
              numberOfMonths={1}
              placeholder={`${LocaleUtils.formatDate(new Date())}`}
              onDayChange={this.generateTasksStore.setDueDate}
            />
          </div>
        </div>
      </Fragment>
    }else{
      checkboxDisplay =  'No tasks available for the selected user\'s permission levels.';
    }
    return (
      <Modal isOpen={isOpen} toggle={this.onCancel}>
        <ModalHeader toggle={this.onCancel}>System Generated Tasks</ModalHeader>
        <ModalBody>
          {checkboxDisplay}
        </ModalBody>
        <ModalFooter>
          <button type="button" className="btn btn-secondary" onClick={this.onCancel}>Cancel</button>{" "}
          {generateBtn}
        </ModalFooter>
      </Modal>
    );
  }
});

export default GenerateTasks;
